import Config from '../Config'
import { unitType } from '../defined'
import LocalStorage from '../defined/localStorage'
import queryString from 'query-string'
import { message } from 'antd'
import numeral from 'numeral'
import _ from 'lodash'
import moment from 'moment'
import { ROUTER_NAME } from '../router/routers'
import dayjs from 'dayjs'
import i18next from 'i18next'

import countries from '../utils/countries.json'
import us_states from '../utils/states.json'
import canada_states from '../utils/canada-states.json'
import UserAction from '../redux/action/user/index'
import { Colors } from '../themes/Colors'
import { ENV } from '../Env'

export const getLabelUnitTemp = (unit) => {
    return unit === unitType.metric ? '°C' : '°F'
}
export const getLabelUnitSpeed = (unit) => {
    return unit === unitType.metric ? 'm/s' : 'mile/h'
}
export const isLogin = () => {
    return LocalStorage.getItem(LocalStorage.DEFINE_KEY.user) ? true : false
}
export const getUserData = () => {
    return isLogin() ? JSON.parse(LocalStorage.getItem(LocalStorage.DEFINE_KEY.user)) : null
}

export function convertPxToRem(px = 16, isUnit = true, rem = 16) {
    return isUnit ? px / rem + 'rem' : px / rem
}

export const getValueFromObjectByKeys = (obj = {}, keys = [], defaultValue = undefined) => {
    const length = keys.length
    if (!obj || length === 0 || Object.keys(obj).length === 0) {
        return defaultValue
    }
    let output = obj
    for (let i = 0; i < length; i++) {
        output = output[keys[i]]
        if (output === 0) {
            return 0
        }
        if (output === false) {
            return false
        }
        if (!output) {
            return defaultValue
        }
    }
    if (output === 0) {
        return 0
    }
    if (output === false) {
        return false
    }
    if (!output) {
        return defaultValue
    }
    return output || defaultValue
}

const serialize = (obj) => {
    var str = []
    for (var p in obj)
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]))
        }
    return str.join('&')
}
export const convertObjectToQuery = (obj, prefix, isAddStartQuery = true) => {
    var str = [],
        p
    for (p in obj) {
        if (obj.hasOwnProperty(p)) {
            var k = prefix ? prefix + '[' + p + ']' : p,
                v = obj[p]
            str.push(
                v !== null && typeof v === 'object'
                    ? serialize({ v, k })
                    : encodeURIComponent(k) + '=' + encodeURIComponent(v)
            )
        }
    }
    return isAddStartQuery ? '?' + str.join('&') : str.join('&')
}

export function myLog(...arg) {
    if (!Config.debug) {
    }
}

export const parseSearchUrl = (href = window.location.href) => {
    let search = href.indexOf('?') !== -1 ? href.split('?')[1] : false
    return search
}

export const parseSearchUrlToObject = (href = window.location.href) => {
    try {
        let search = href.indexOf('?') !== -1 ? href.split('?')[1] : false
        if (search) {
            search = search.replace('+', '%2B')
            return queryString.parse(search)
        }
        return {}
    } catch (error) {
        return {}
    }
}

export const checkFieldExistsInObject = ({ object, key } = { object: {}, key: '' }) => {
    if (typeof object !== 'object') {
        return false
    } else if (object.length !== undefined) {
        return false
    }
    if (key && key.toString) {
        key = key.toString()
    } else if (key && typeof key !== 'string') {
        return false
    } else {
        return false
    }
    let isExists = false
    Object.keys(object).map((keyInObject) => {
        if (keyInObject === key) {
            isExists = true
        }
        return 0
    })
    return isExists
}
export const pushStateToUrl = (params, navigate) => {
    let queryUrl = ''
    if (
        params &&
        Object.keys(params).length === 1 &&
        checkFieldExistsInObject({
            object: params,
            key: 'page'
        }) &&
        parseSearchUrl()
    ) {
        params = { ...parseSearchUrlToObject(), ...params }
    }
    Object.keys(params).map((key, index) => {
        if (params[key] === '' || params[key] === undefined) return
        let connect = index ? '&' : ''
        queryUrl += connect + key + '=' + params[key]
        return 0
    })
    navigate({ search: queryUrl })
}
export const objectToQuerySearch = (object) => {
    let queryUrl = ''
    Object.keys(object).map((key, index) => {
        let connect = index ? '&' : ''
        queryUrl += connect + key + '=' + object[key]
        return 0
    })
    return queryUrl
}
export const MESSAGE_TYPE = {
    info: 'info',
    warning: 'warning',
    error: 'error',
    success: 'success'
}
export const messageManager = ({ type = MESSAGE_TYPE.info, messageShow = '', duration = 5 }) => {
    switch (type) {
        case MESSAGE_TYPE.info:
            message.info(messageShow || 'Info', duration)
            break
        case MESSAGE_TYPE.error:
            message.error(messageShow || 'Error', duration)
            return messageShow
            break
        case MESSAGE_TYPE.warning:
            message.warning(messageShow || 'Warning', duration)
            break
        case MESSAGE_TYPE.success:
            message.success(messageShow || 'Success', duration)
            break
        default:
            message.info(messageShow || 'Message', duration)
            break
    }
}
export const CreditformatNumber = (value) => {
    return numeral(value).format('0,0')
}

export const deepCopyObject = (obj = {}) => {
    return JSON.parse(JSON.stringify(obj))
}

export function shouldComponentUpdate(nextProps, nextState) {
    return !_.isEqual(this.props, nextProps) || !_.isEqual(this.state, nextState)
}

export const formatTimeText = (time = moment(), toFormat = 'HH:mm A') => {
    const startToday = moment().startOf('day').valueOf()
    const endToday = moment().endOf('day').valueOf()
    const startTomorrow = moment().subtract(1, 'day').startOf('day').valueOf()
    const endTomorrow = moment().subtract(1, 'day').endOf('day').valueOf()
    const valueTime = moment(time).valueOf()
    if (valueTime < endTomorrow && valueTime > startTomorrow) {
        return 'yesterday'
    }
    if (valueTime >= startToday && valueTime <= endToday) {
        return moment(time).format(toFormat)
    }
    return moment(time).format('MMM D,YYYY')
}

export const getUserNameShow = (userInfo = {}) => {
    return getValueFromObjectByKeys(userInfo, ['profile', 'user', 'name'], '')
}
export const getUserProfileByKey = (userInfo = {}, key) => {
    return getValueFromObjectByKeys(userInfo, ['profile', 'user', key], '')
}
export const getUserByKey = (userInfo = {}, key) => {
    return getValueFromObjectByKeys(userInfo, ['user', key], '')
}
export const getUserId = (userInfo = {}) => {
    return getValueFromObjectByKeys(userInfo, ['user', 'id'], '')
}

export const formatImageUrl = (url = '') => {
    return url // url ? url.split("?")[0] : "";
}
export const navigateToContactUs = (navigate) => {
    if (!navigate) return
    if (LocalStorage.getItem(LocalStorage.DEFINE_KEY.ACCESS_TOKEN)) {
        navigate(ROUTER_NAME.contactUsPrivate)
    } else {
        navigate(ROUTER_NAME.contactUs)
    }
}
export const getLinkContactUs = () => {
    if (LocalStorage.getItem(LocalStorage.DEFINE_KEY.ACCESS_TOKEN)) {
        return ROUTER_NAME.contactUsPrivate
    } else {
        return ROUTER_NAME.contactUs
    }
}

export const reloadApp = () => {
    LocalStorage.clear()
    window.location.reload()
}

export const updateBranding = async () => {
    try {
        if (ENV.CURRENT_DOMAIN === ENV.MAIN_DOMAIN_URL) return;
        UserAction.saveBranding()
    } catch {
    }
}

export const createFormData = (
    formData = new FormData(),
    key,
    data,
    listKeyFiles = [],
    realKey
) => {
    myLog('createFormData=>1', key, data)
    if (realKey && listKeyFiles.includes(realKey)) {
        formData.append(key, data)
    } else if (data === Object(data) || Array.isArray(data)) {
        for (let i in data) {
            myLog('createFormData=>', i, data, data[i])
            createFormData(
                formData,
                key + (Array.isArray(data) ? '[' + i + ']' : i),
                data[i],
                listKeyFiles,
                i
            )
        }
    } else {
        formData.append(key, data)
    }
}

export const confirmBase = ({ message, onOk, onCancel }) => {
    let text = message || 'Please confirm action?'
    if (window.confirm(text) === true) {
        onOk && onOk()
    } else {
        onCancel && onCancel()
    }
}

export const getFileNameFromUrl = (url) => {
    return url.indexOf('?') !== -1
        ? url.split('?')[0].substring(url.lastIndexOf('/') + 1)
        : url.substring(url.lastIndexOf('/') + 1)
}

export function compare(a, b) {
    if (a.name < b.name) {
        return -1
    }
    if (a.name > b.name) {
        return 1
    }
    return 0
}

export const renderCountries = () => {
    const usObject = countries.find((country) => country?.name === 'United States')
    const countriesSorted = countries
        .filter((country) => country?.name !== 'United States')
        .sort(compare)
    countriesSorted.unshift(usObject)
    return countriesSorted.map((country) => {
        return {
            key: country.countryCode,
            title: country.name
        }
    })
}

export const renderCountriesPhoneCode = () => {
    const usObject = countries.find((country) => country?.name === 'United States')
    const countriesSorted = countries
        .filter((country) => country?.name !== 'United States' && Number(country?.phone) !== 1)
        .sort(compare)
    countriesSorted.unshift(usObject)
    return countriesSorted
        ?.filter((item) => item?.phone?.length > 0 && item?.phone?.length < 5)
        ?.map((country) => {
            return {
                key: country.phone,
                short: `${country.countryCodeAlpha3} +${country.phone}`,
                title: `${country.name} +${country.phone}`
            }
        })
}

export const WHITELABEL_WEB_ROLES = [
    { key: 'SW', value: 'SW', label: 'Service Writer' },
    { key: 'OP', value: 'OP', label: 'Order Processor' }
]
export const WHITE_LABEL_WEB_ROLES_LABEL = {
    'SW': 'Service Writer',
    'OP': 'Order Processor'
}
export const WHITE_LABEL_WEB_ROLES_VALUES = {
    'Service Writer': 'SW',
    'Order Processor': 'OP'
}
export const renderStates = (type) => {
    let statesSorted = [
        {
            key: 'N/A',
            title: 'N/A'
        }
    ]
    if (type === 'US') {
        statesSorted = us_states.sort(compare)
    } else if (type === 'CA') {
        statesSorted = canada_states.sort(compare)
    }
    return statesSorted.map((state) => {
        return {
            key: state.abbreviation,
            title: state.name
        }
    })
}

export const validateEmail = (email) => {
    return String(email)
        .toLowerCase()
        .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
}

export function getCreditCardType(creditCardNumber) {
    var patterns = {
        Visa: /^4/,
        MasterCard: /^5[1-5]/,
        'American Express': /^3[47]/,
        Discover: /^6(?:011|5)/
    }

    for (var cardType in patterns) {
        if (creditCardNumber.match(patterns[cardType])) {
            return cardType
        }
    }

    return 'Unknown'
}

export function getCreditCardTypeString(brandName) {
    const brand =
        brandName === 'visa'
            ? 'Visa'
            : brandName === 'mastercard'
                ? 'MasterCard'
                : brandName === 'American Express'
                    ? 'Amex'
                    : brandName === 'discover'
                        ? 'Discover'
                        : null

    return brand || 'Unknown'
}

export const limitLength = (string = '', maxLength) => string?.substr(0, maxLength)

export const removeNonNumber = (string = '') => string.replace(/[^\d]/g, '')
export const removeLeadingSpaces = (string = '') => string.replace(/^\s+/g, '')

export const formatExpiry = (expiry) => {
    const sanitized = limitLength(removeNonNumber(expiry), 4)
    if (sanitized.match(/^[2-9]$/)) {
        return `0${sanitized}`
    }
    if (sanitized.length > 2) {
        return `${sanitized.substr(0, 2)}/${sanitized.substr(2, sanitized.length)}`
    }
    return sanitized
}

export const formatCreditNumber = (number) => {
    const numberSanitized = removeNonNumber(number)
    const maxLength = 19
    const lengthSanitized = limitLength(numberSanitized, maxLength)
    return addSpacingToCreditCardNumber(lengthSanitized)
}

function addSpacingToCreditCardNumber(creditCardNumber) {
    creditCardNumber = creditCardNumber.replace(/\s+/g, '').replace(/-/g, '')

    var cardType = getCreditCardType(creditCardNumber)

    var spacingPattern
    switch (cardType) {
        case 'Visa':
            spacingPattern = [4, 4, 4, 4]
            break
        case 'MasterCard':
            spacingPattern = [4, 4, 4, 4]
            break
        case 'American Express':
            spacingPattern = [4, 6, 5]
            break
        case 'Discover':
            spacingPattern = [4, 4, 4, 4]
            break
        default:
            return creditCardNumber
    }

    var formattedNumber = ''
    var currentPosition = 0
    for (var i = 0; i < spacingPattern.length; i++) {
        var segmentLength = spacingPattern[i]
        var segment = creditCardNumber.substr(currentPosition, segmentLength)
        formattedNumber += segment + ' '
        currentPosition += segmentLength
    }

    return formattedNumber.trim()
}

export const verifyCard = (values) => {
    let errors = {}

    for (const [key, value] of Object.entries(values)) {
        if (key === 'cvc') {
            if (value?.length < 3 || !Number(value))
                errors = {
                    ...errors,
                    ...{ [key]: `Invalid CVV` }
                }
        } else if (key === 'card_holder') {
            if (value?.length > 15) {
                errors = {
                    ...errors,
                    ...{ [key]: `Card holder name should not be more than 15 characters` }
                }
            } else if (value?.length < 1) {
                errors = {
                    ...errors,
                    ...{ [key]: `Invalid ${key.replace(/_/g, ' ')}` }
                }
            }
        } else if (key === 'number') {
            if (!isValidCard(value) || value?.length < 1) {
                errors = {
                    ...errors,
                    ...{ [key]: `Invalid card number` }
                }
            }
        } else if (key === 'expiration_date') {
            if (!value?.exp_year || !value?.exp_month) {
                errors = {
                    ...errors,
                    ...{ [key]: `Invalid expiry date` }
                }
            } else if (dayjs().year() > Number('20' + value?.exp_year)) {
                errors = {
                    ...errors,
                    ...{ [key]: `Invalid expiry date` }
                }
            } else if (dayjs().year() === Number('20' + value?.exp_year)) {
                if (dayjs().month() + 1 > value?.exp_month) {
                    errors = {
                        ...errors,
                        ...{ [key]: `Invalid expiry date` }
                    }
                }
            }
        } else if (value?.length < 1) {
            errors = {
                ...errors,
                ...{ [key]: `Invalid ${key.replace(/_/g, ' ')}` }
            }
        }
    }
    return errors
}

function isValidCard(cardNumber) {
    let nCheck = 0,
        bEven = false
    const sCardNum = String(cardNumber).replace(/\D/g, '')

    for (let n = sCardNum.length - 1; n >= 0; n--) {
        let cDigit = sCardNum.charAt(n),
            nDigit = parseInt(cDigit, 10)

        if (bEven && (nDigit *= 2) > 9) {
            nDigit -= 9
        }

        nCheck += nDigit
        bEven = !bEven
    }

    return nCheck % 10 === 0
}

export const translate = (data) => {
    return i18next.t(data)
}

export const REGEX = { password: /(?=.*\d)(?=.*[A-Z])(?=.*\W).{8,8}/ }

export function fileToUrl(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
            resolve(reader.result)
        }
        reader.onerror = reject
        reader.readAsDataURL(file)
    })
}

export async function urlToFile(url, filename) {
    const response = await fetch(url)
    const blob = await response.blob()
    return new File([blob], filename)
}

/**
 * @param orderDetails - quote object
 * @param {boolean} isSW - is logged in user a service writer
 * @returns {string} status - status of an order
 */
export const handleStatus = (orderDetails, isSW) => {
    const { quotes } = orderDetails
    const singleQuote = quotes && quotes[0]
    const quoteStatus = singleQuote?.status

    if (orderDetails.status === 'SERVICE ACCEPTED' || orderDetails.status === 'DELIVERED') {
        return orderDetails.status
    } else if (!quotes || quotes.length === 0) {
        return orderDetails.status
    } else {
        return quoteStatus
    }
}

/**
 * @param {string} status - status of the quote
 * @param {boolean} isSW - is logged in user a service writer
 * @returns {string} - returns the status label of the quote
 */

export const filterQuoteStatus = (status, isSW = false) => {
    switch (status) {
        case 'INPROGRESS':
            return translate('In Progress')
        case 'SENT':
            return isSW ? 'Action Required' : 'Quote Sent'
        case 'CUSTOMER ACCEPTED':
            return 'Accepted - Pending Dealer Review'
        case 'SERVICE ACCEPTED PENDING':
            return 'Accepted - Pending Dealer Review'
        case 'ACCEPTED':
            return 'Paid'
        case 'NS':
            return translate('Open order')
        case 'SERVICE ACCEPTED':
            return 'Service Accepted'
        case 'DELIVERED':
            return 'Parts Ordered'
        default:
            return translate('Open order')
    }
}

export const filterQuoteStatusColor = (status, isSW) => {
    switch (status) {
        case 'SENT':
            return isSW ? Colors.red : Colors.primary
        case 'CUSTOMER ACCEPTED':
            return Colors.navyBlue
        case 'SERVICE ACCEPTED PENDING':
            return Colors.navyBlue
        case 'ACCEPTED':
            return Colors.open_order
        case 'SERVICE ACCEPTED':
            return Colors.open_order
        case 'NS':
            return Colors.red
        case 'DELIVERED':
            return '#00BCD4'
        default:
            return Colors.red
    }
}

export const filterQuoteStatusBackground = (status, isSW) => {
    switch (status) {
        case 'SENT':
            return isSW ? 'rgba(255, 32, 32, 0.08)' : 'rgba(251, 181, 22, 0.08)'
        case 'CUSTOMER ACCEPTED':
            return 'rgba(20, 82, 145, 0.08)'
        case 'SERVICE ACCEPTED PENDING':
            return 'rgba(20, 82, 145, 0.08)'
        case 'ACCEPTED':
            return 'rgba(16, 185, 129, 0.08)'
        case 'SERVICE ACCEPTED':
            return 'rgba(16, 185, 129, 0.08)'
        case 'NS':
            return 'rgba(255, 32, 32, 0.08)'
        case 'DELIVERED':
            return 'rgba(0, 188, 212, 0.08)'
        default:
            return 'rgba(255, 32, 32, 0.08)'
    }
}

export const resizeImage = (blob, sizes) => {
    return new Promise((resolve) => {
        const img = new Image()
        const objectUrl = URL.createObjectURL(blob)
        img.src = objectUrl

        img.onload = () => {
            const resizedImagesPromises = sizes.map(
                (size) =>
                    new Promise((resolve) => {
                        const canvas = document.createElement('canvas')
                        const ctx = canvas.getContext('2d')

                        canvas.width = size
                        canvas.height = size

                        // White background (important for splash/icons)
                        ctx.fillStyle = '#ffffff'
                        ctx.fillRect(0, 0, size, size)

                        // Maskable safe padding (15%)
                        const padding = size * 0.15
                        const availableSize = size - padding * 2

                        // Maintain aspect ratio
                        const ratio = Math.min(
                            availableSize / img.width,
                            availableSize / img.height
                        )

                        const drawWidth = img.width * ratio
                        const drawHeight = img.height * ratio

                        const offsetX = (size - drawWidth) / 2
                        const offsetY = (size - drawHeight) / 2

                        ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight)

                        canvas.toBlob(
                            (resizedBlob) => {
                                const resizedUrl = URL.createObjectURL(resizedBlob)
                                resolve({ size, url: resizedUrl })
                            },
                            'image/png',
                            1
                        )
                    })
            )

            Promise.all(resizedImagesPromises).then((results) => {
                resolve(results)
                URL.revokeObjectURL(objectUrl)
            })
        }

        img.onerror = () => {
            URL.revokeObjectURL(objectUrl)
        }
    })
}

export function imageResize(imageUrl) {
  return new Promise((resolve, reject) => {
        const domain =
            ENV.CURRENT_HOST_NAME !== 'localhost'
                ? ENV.CURRENT_DOMAIN
                : 'https://www.shoredealsnow.com'
        const encodedUrl = encodeURIComponent(btoa(imageUrl))
        fetch(`${domain}/api/v1/white-label-partner/fetch-image/?url=${encodedUrl}`, {
            method: 'GET'
        })
            .then((response) => {
                if (!response.ok) throw new Error(`HTTP ${response.status}`)
                return response.blob()
            })
            .then((blob) => {
                let urls = resizeImage(blob, [72, 96, 128, 144, 152, 192, 384, 512])
                resolve(urls)
            })
            .catch(reject)
        })
}

export const getStatus = (status, isDT = false) => {
    switch (status) {
        case 'PARTS_ORDERED':
            return 'Parts Ordered';

        case 'INPROGRESS':
            return translate('In Progress');

        case 'SENT':
            return isDT ? translate('Pending') : translate('actionRequired');

        case 'CUSTOMER ACCEPTED':
            return 'Accepted - Pending Dealer Review';

        case 'ACCEPTED':
            return 'Paid';

        case 'SERVICE ACCEPTED PENDING':
            return 'Accepted - Pending Dealer Review';

        case 'NS':
            return translate('Pending');

        default:
            return translate('Pending');
    }
};

export const getStatusColor = (status, isDT = false) => {
  switch (status) {
    case 'PARTS_ORDERED':
      return '#00BCD4';

    case 'SENT':
      return isDT ? Colors.primary : '#E21414';

    case 'CUSTOMER ACCEPTED':
    case 'SERVICE ACCEPTED PENDING':
      return Colors.navyBlue;

    case 'ACCEPTED':
      return Colors.open_order;

    case 'NS':
      return Colors.primary;

    default:
      return Colors.primary;
  }
};

export const getStatusBackground = (status, isDT = false) => {
  switch (status) {
    case 'PARTS_ORDERED':
      return 'rgba(0, 188, 212, 0.08)';

    case 'SENT':
      return isDT ? 'rgba(251, 181, 22, 0.08)' : 'rgba(255, 32, 32, 0.08)';

    case 'CUSTOMER ACCEPTED':
    case 'SERVICE ACCEPTED PENDING':
      return 'rgba(20, 82, 145, 0.08)';

    case 'ACCEPTED':
      return 'rgba(16, 185, 129, 0.08)';

    case 'NS':
      return 'rgba(251, 181, 22, 0.08)';

    default:
      return 'rgba(251, 181, 22, 0.08)';
  }
};

export const getRoleLabel = (role) => {
    if (Object.keys(WHITE_LABEL_WEB_ROLES_LABEL).includes(role)) {
        return WHITE_LABEL_WEB_ROLES_LABEL[role]
    }
    return role
}

export const getRoleValue = (role) => {

    if (Object.keys(WHITE_LABEL_WEB_ROLES_VALUES).includes(role)) {
        return WHITE_LABEL_WEB_ROLES_VALUES[role]
    }
    return role
}
export const getOrderStatusDisplay = (row = {}) => {
    const label = (row?.status || '');
    const normalized = label.trim().toLowerCase().replace(/"/g, '');

    switch (true) {
        case normalized.startsWith('paid') || normalized.startsWith('service accepted'):
            return { label, bg: 'rgba(16, 185, 129, 0.08)', color: 'rgba(19, 139, 23, 1)' };

        case normalized === 'quote sent':
            return { label: 'Quote Sent', bg: 'rgba(251, 181, 22, 0.08)', color: Colors.primary };

        case normalized.startsWith('in progress'):
            return { label, bg: 'rgba(231, 244, 255, 0.08)', color: 'rgba(15, 92, 202, 1)' };

        case normalized === 'open order':
            return { label, bg: 'rgba(255, 32, 32, 0.08)', color: Colors.red };
        
        case normalized.startsWith('accepted'):
            return {label, bg: 'rgba(20, 82, 145, 0.08)', color: Colors.navyBlue}

        case normalized.startsWith('parts'):
            return {label, bg: 'rgba(0, 188, 212, 0.08)', color: '#00BCD4'}

        default:
            return { label, bg: 'rgba(245, 245, 245, 1)', color: 'rgba(102, 102, 102, 1)' };
    }
}

export function trimTransparent(canvas) {
    const ctx = canvas.getContext("2d");
    const w = canvas.width;
    const h = canvas.height;

    const imgData = ctx.getImageData(0, 0, w, h).data;

    let top = null, left = null, right = null, bottom = null;

    // ✅ tolerance to ignore near-transparent pixels
    const ALPHA_THRESHOLD = 10; // tweakable (5–20)

    for (let y = 0; y < h; y++) {
        for (let x = 0; x < w; x++) {
            const alpha = imgData[(y * w + x) * 4 + 3];

            if (alpha > ALPHA_THRESHOLD) {
                if (top === null) top = y;
                if (left === null || x < left) left = x;
                if (right === null || x > right) right = x;
                bottom = y;
            }
        }
    }

    if (top === null) return canvas;

    // ✅ add small padding to prevent tight crop issues
    const PADDING = 4;

    left = Math.max(0, left - PADDING);
    top = Math.max(0, top - PADDING);
    right = Math.min(w, right + PADDING);
    bottom = Math.min(h, bottom + PADDING);

    const trimW = right - left;
    const trimH = bottom - top;

    const trimmed = document.createElement("canvas");
    trimmed.width = trimW;
    trimmed.height = trimH;

    trimmed
        .getContext("2d")
        .putImageData(
            ctx.getImageData(left, top, trimW, trimH),
            0,
            0
        );

    return trimmed;
}

export const FLEET_STATUS = {
  IN_STOCK: 1,
  ON_ORDER: 2,
  BACKORDERED: 3
};

export const FLEET_STATUS_REVERSE = {
  1: "IN_STOCK",
  2: "ON_ORDER",
  3: "BACKORDERED"
};

export const getFleetStatusConfig = (status) => {
  const CONFIG = {
    1: {
      label: "In Stock",
      color: "#047857",
      bg: "#D1FAE5",
      border: "#A7F3D0"
    },
    2: {
      label: "On Order",
      color: "#B45309",
      bg: "#FEF3C7",
      border: "#FCD34D"
    },
    3: {
      label: "Backordered",
      color: "#B91C1C",
      bg: "#FEE2E2",
      border: "#FCA5A5"
    }
  };

  return CONFIG[status] || {
    label: "-",
    color: "#6B7280",
    bg: "#F3F4F6",
    border: "#E5E7EB"
  };
};